import { ReactNode } from 'react';
import * as Styles from './auth-layout.module.less';
import { Grid, Transition } from 'semantic-ui-react';
import { LogoST } from 'components';
import { LoginRouter } from '../../login/components/login-router/login-router';
import classNames from 'classnames';

import * as FormStylesShared from '../../styles/form-styles-shared.module.less';

interface CenteredLayoutProps {
    isCornerLogoVisible?: boolean;
    shouldLogoAnimateOnMount?: boolean;
    children?: ReactNode;
}

export const CenteredLayout = (props: CenteredLayoutProps) => (
    <Grid className={FormStylesShared.gridStyles}>
        <Grid.Column width={16} verticalAlign="top">
            <Transition
                duration={800}
                transitionOnMount={props.shouldLogoAnimateOnMount}
                animation="fade left"
                visible={props.isCornerLogoVisible}
            >
                <div className={Styles.logoContainer}>
                    <LogoST height={66} width={61} />
                </div>
            </Transition>
            <div className={FormStylesShared.form}>{props.children}</div>
        </Grid.Column>
    </Grid>
);

export const AuthLayout = () => {
    return (
        <Grid className={classNames(FormStylesShared.gridStyles, 'auth-layout')}>
            <Grid.Row className={FormStylesShared.rowStyles}>
                <LoginRouter />
            </Grid.Row>
        </Grid>
    );
};
